<template>
  <div class="login">
    <DevelopmentBanner />
    <div class="frow centered">
      <div class="box">
        <label class="label">Username:</label>
        <input
          v-model="username"
          class="input"
          type="text"
          placeholder="Username"
        />
        <br />
        <br />
        <label class="label">Password:</label>
          <input
          v-model="password"
          class="input"
          type="password"
          placeholder="Password"
        />
        <br />
        <br />
        <button
          class="button"
          @click="login"
        >
            Login
        </button>
        <br />
        <br />
        <router-link to="/forgot-password">Forgot Password</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import DevelopmentBanner from '@/components/DevelopmentBanner.vue';

export default {
  name: 'login',
  components: {
    DevelopmentBanner,
  },
  data() {
    return {
      username: '',
      password: '',
    };
  },
  computed: {
    API() {
      return this.$API;
    },
  },
  methods: {
    login() {
      this.axios
        .post(`${this.$API}/auth/local`, {
          identifier: this.username,
          password: this.password,
        })
        .then((response) => {
          this.$store.commit('login', response.data);
        })
        .catch(() => null);
    },
  },
  created() {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push('/manage');
    }
  },
};
</script>
<style lang="scss" scoped>
.login {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  width: 100%;
  .development-banner {
    flex-shrink: 0;
  }
  > .frow {
    flex: 1 0 auto;
    padding: 16px 0;
  }
}
.box {
  height: 300px;
  width: 300px;
}
</style>
